import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLaunch } from "../../../auth/useAuth";
import CurrencyIcon from "../ui/CurrencyIcon";
import { GEMS_ENABLED, formatCurrencyAmount, isAmountHidden, resolveDisplayCurrency } from "../../common/currencies";

const Navbar = () => {
  const { balance, gemsBalance } = useLaunch();
  const { gameId } = useParams();
  const gameMetaData = useSelector((state) => state.gamesMeta.data);
  const gameDisplayName = gameId
    ? gameMetaData?.lobbyMeta?.[gameId]?.displayName || gameId
    : null;

  // Cash + virtual balances render in the active client's currency (Pixel: RCR/GEM).
  const cashCurrency = resolveDisplayCurrency("USD");
  const gemCurrency = resolveDisplayCurrency("GEMS");
  const displayBalance =
    balance != null ? formatCurrencyAmount(balance, cashCurrency) : "--";
  const displayGems =
    gemsBalance != null ? formatCurrencyAmount(gemsBalance, gemCurrency) : "--";
  const showGems = GEMS_ENABLED && !isAmountHidden("GEMS");
  // DraftKings gets its own navbar layout (see below); other operators keep the default.
  const isDraftKings = process.env.REACT_APP_CLIENT === "draftkings";

  const gemsBadge = showGems && (
    <div className="flex items-center gap-1">
      <span className="text-[9pt] font-medium text-white">
        {displayGems}
      </span>
      <CurrencyIcon code={gemCurrency} className="w-3 h-3" />
    </div>
  );

  // DraftKings: no game title, centred "Balance: $x" in DK green.
  if (isDraftKings) {
    return (
      <nav className="w-full flex flex-col justify-center">
        <div className="w-full max-w-[375px] sm:max-w-2xl mx-auto px-3 py-1 flex items-center justify-center gap-3">
          {gemsBadge}
          <div className="flex items-center gap-1 text-[11pt] font-semibold">
            <span className="text-white">Balance:</span>
            <span className="text-[#53D337] flex items-center gap-0.5">
              <CurrencyIcon code={cashCurrency} className="w-3 h-3" />
              {displayBalance}
            </span>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="w-full flex flex-col justify-center">
      <div className="w-full max-w-[375px] sm:max-w-2xl mx-auto px-3 py-1 flex items-center justify-between gap-2">
        {gameDisplayName && (
          <span className="text-[9pt] font-semibold text-white truncate">
            {gameDisplayName}
          </span>
        )}

        <div className="flex items-center gap-3 shrink-0 ml-auto">
          {gemsBadge}
          <div className="flex items-center gap-1">
            <span className="text-[9pt] font-medium text-white flex items-center gap-0.5">
              <CurrencyIcon code={cashCurrency} className="w-3 h-3" />
              {displayBalance}
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
